var Afghanistan = "Afeganistão";
var Albania = "Albânia";
var Algeria = "Argélia";
var Andorra = "Andorra";
var Angola = "Angola";
var Anguilla = "Anguilla";
var Antarctica = "Antártica";
var Argentina = "Argentina";
var Armenia = "Armênia";
var Aruba = "Aruba";
var Australia = "Austrália";
var Austria = "Áustria";
var Azerbaijan = "Azerbaijão";
var Bahamas = "Bahamas";
var Bahrain = "Bahrein";
var Bangladesh = "Bangladesh";
var Barbados = "Barbados";
var Belarus = "Bielorrússia";
var Belgium = "Bélgica";
var Belize = "Belize";
var Benin = "Benin";
var Bermuda = "Bermudas";
var Bhutan = "Butão";
var Bolivia = "Bolívia";
var Botswana = "Botsuana";
var Brazil = "Brasil";
var Bulgaria = "Bulgária";
var Burundi = "Burundi";
var Cambodia = "Camboja";
var Cameroon = "Camarões";
var Canada = "Canadá";
var Chad = "Chade";
var Chile = "Chile";
var China = "China";
var Colombia = "Colômbia";
var Comoros = "Comores";
var Congo = "Congo";
var Croatia = "Croácia";
var Cuba = "Cuba";
var Cyprus = "Chipre";
var Denmark = "Dinamarca";
var Djibouti = "Djibuti";
var Dominica = "Dominica";
var Ecuador = "Equador";
var Egypt = "Egito";
var Eritrea = "Eritreia";
var Estonia = "Estônia";
var Ethiopia = "Etiópia";
var Fiji = "Fiji";
var Finland = "Finlândia";
var France = "França";
var Gabon = "Gabão";
var Gambia = "Gâmbia";
var Georgia = "Geórgia";
var Germany = "Alemanha";
var Ghana = "Gana";
var Gibraltar = "Gibraltar";
var Greece = "Grécia";
var Greenland = "Groenlândia";
var Grenada = "Granada";
var Guadeloupe = "Guadalupe";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernsey";
var Guinea = "Guiné";
var Guyana = "Guiana";
var Haiti = "Haiti";
var Honduras = "Honduras";
var Hungary = "Hungria";
var Iceland = "Islândia";
var India = "Índia";
var Indonesia = "Indonésia";
var Iraq = "Iraque";
var Ireland = "Irlanda";
var Israel = "Israel";
var Italy = "Itália";
var Jamaica = "Jamaica";
var Japan = "Japão";
var Jersey = "Jersey";
var Jordan = "Jordânia";
var Kazakhstan = "Cazaquistão";
var Kenya = "Quênia";
var Kiribati = "Kiribati";
var Kuwait = "Kuwait";
var Kyrgyzstan = "Quirguistão";
var Latvia = "Letônia";
var Lebanon = "Líbano";
var Lesotho = "Lesoto";
var Liberia = "Libéria";
var Libya = "Jamahiriya Árabe da Líbia";
var Liechtenstein = "Liechtenstein";
var Lithuania = "Lituânia";
var Luxembourg = "Luxemburgo";
var Macao = "Macao";
var Madagascar = "Madagascar";
var Malawi = "Malawi";
var Malaysia = "Malásia";
var Maldives = "Maldivas";
var Mali = "Mali";
var Malta = "Malta";
var Martinique = "Martinica";
var Mauritania = "Mauritânia";
var Mauritius = "Maurício";
var Mayotte = "Mayotte";
var Mexico = "México";
var Monaco = "Mônaco";
var Mongolia = "Mongólia";
var Montenegro = "Montenegro";
var Montserrat = "Montserrat";
var Morocco = "Marrocos";
var Mozambique = "Moçambique";
var Myanmar = "Myanmar";
var Namibia = "Namíbia";
var Nauru = "Nauru";
var Nepal = "Nepal";
var Netherlands = "Países Baixos";
var Nicaragua = "Nicarágua";
var Niger = "Níger";
var Nigeria = "Nigéria";
var Niue = "Niue";
var Norway = "Noruega";
var Oman = "Omã";
var Pakistan = "Paquistão";
var Palau = "Palau";
var Panama = "Panamá";
var Paraguay = "Paraguai";
var Peru = "Peru";
var Philippines = "Filipinas";
var Pitcairn = "Pitcairn";
var Poland = "Polônia";
var Portugal = "Portugal";
var Qatar = "Qatar";
var Romania = "Romênia";
var Rwanda = "Ruanda";
var Samoa = "Samoa";
var Senegal = "Senegal";
var Serbia = "Sérvia";
var Seychelles = "Seychelles";
var Singapore = "Singapura";
var Slovakia = "Eslováquia";
var Slovenia = "Eslovênia";
var Somalia = "Somália";
var Spain = "Espanha";
var Sudan = "Sudão";
var Suriname = "Suriname";
var Swaziland = "Suazilândia";
var Sweden = "Suécia";
var Switzerland = "Suíça";
var Taiwan = "Taiwan";
var Tajikistan = "Tajiquistão";
var Thailand = "Tailândia";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Tunísia";
var Turkey = "Turquia";
var Turkmenistan = "Turcomenistão";
var Tuvalu = "Tuvalu";
var Uganda = "Uganda";
var Ukraine = "Ucrânia";
var Uruguay = "Uruguai";
var Uzbekistan = "Uzbequistão";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Iêmen";
var Zambia = "Zâmbia";
var Zimbabwe = "Zimbábue";
var countries = {
	"Country or region": "País ou região",
	"United States": "Estados Unidos",
	Afghanistan: Afghanistan,
	"Åland Islands": "Ilhas Åland",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "Samoa Americana",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antígua e Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bósnia e Herzegovina",
	Botswana: Botswana,
	"Bouvet Island": "Ilha Bouvet",
	Brazil: Brazil,
	"British Indian Ocean Territory": "Território do Oceano Índico Britânico",
	"Brunei Darussalam": "Brunei Darussalam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Cabo Verde",
	"Cayman Islands": "Ilhas Cayman",
	"Central African Republic": "República Centro-Africana",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Ilha Christmas",
	"Cocos (Keeling) Islands": "Ilhas Cocos (Keeling)",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "República Democrática do Congo",
	"Cook Islands": "Ilhas Cook",
	"Costa Rica": "Costa Rica",
	"Côte d'Ivoire": "Costa do Marfim",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "República Tcheca",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "República Dominicana",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Guiné Equatorial",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Ilhas Falkland (Malvinas)",
	"Faroe Islands": "Ilhas Faroé",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Guiana Francesa",
	"French Polynesia": "Polinésia Francesa",
	"French Southern Territories": "Terras Austrais Francesas",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guiné-Bissau",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Ilha Heard e Ilhas McDonald",
	"Holy See (Vatican City State)": "Santa Sé (Cidade do Vaticano)",
	Honduras: Honduras,
	"Hong Kong": "Hong Kong",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "República Islâmica do Irã",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Ilha de Man",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "República Popular Democrática da Coreia",
	"Korea, Republic of": "República da Coreia",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "República Democrática Popular do Laos",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Antiga República Iugoslava da Macedônia",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Ilhas Marshall",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Micronésia, Estados Federados da",
	"Moldova, Republic of": "Moldávia, República da",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Antilhas Neerlandesas",
	"New Caledonia": "Nova Caledônia",
	"New Zealand": "Nova Zelândia",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Ilha Norfolk",
	"Northern Mariana Islands": "Ilhas Marianas do Norte",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Territórios Palestinos, Ocupados",
	Panama: Panama,
	"Papua New Guinea": "Papua Nova Guiné",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Porto Rico",
	Qatar: Qatar,
	"Réunion": "Reunião",
	Romania: Romania,
	"Russian Federation": "Federação Russa",
	Rwanda: Rwanda,
	"Saint Helena": "Santa Helena",
	"Saint Kitts and Nevis": "São Cristóvão e Névis",
	"Saint Lucia": "Santa Lúcia",
	"Saint Pierre and Miquelon": "Saint-Pierre e Miquelon",
	"Saint Vincent and The Grenadines": "São Vicente e Granadinas",
	Samoa: Samoa,
	"San Marino": "San Marino",
	"Sao Tome and Principe": "São Tomé e Príncipe",
	"Saudi Arabia": "Arábia Saudita",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Serra Leão",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Ilhas Salomão",
	Somalia: Somalia,
	"South Africa": "África do Sul",
	"South Georgia and The South Sandwich Islands": "Ilhas Geórgia do Sul e Sandwich do Sul",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard e Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "República Árabe Síria",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "República Unida da Tanzânia",
	Thailand: Thailand,
	"Timor-Leste": "Timor-Leste",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinidad e Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Ilhas Turcas e Caicos",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Emirados Árabes Unidos",
	"United Kingdom": "Reino Unido",
	"United States Minor Outlying Islands": "Ilhas Menores Distantes dos Estados Unidos",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Vietnã",
	"Virgin Islands, British": "Ilhas Virgens (Britânicas)",
	"Virgin Islands, U.S.": "Ilhas Virgens (EUA)",
	"Wallis and Futuna": "Wallis e Futuna",
	"Western Sahara": "Saara Ocidental",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
